
import httpClient from './httpClient';
const prefix = 'core'

export default {
  async export_invoice(body) {
    const { data } = await httpClient({ requiresAuth: true }).post(`/${prefix}/report/export-invoice`, { data: body });

    return data;
  },
  async export_receipt(body) {
    const { data } = await httpClient({ requiresAuth: true }).post(`/${prefix}/report/export-receipt`, { data: body });

    return data;
  },
  async export_qt(body) {
    const { data } = await httpClient({ requiresAuth: true }).post(`/${prefix}/report/export-qt`, { data: body });

    return data;
  },
  async booking_gas_report (id) {
    const { data } = await httpClient({ requiresAuth: true }).get(`/${prefix}/report/booking-gas-report/${id}`);
    
    return data;
  },
  async stops () {
    const { data } = await httpClient({ requiresAuth: true }).get(`/${prefix}/report/stops`);

    return data;
  },
  async car_used () {
    const { data } = await httpClient({ requiresAuth: true }).get(`/${prefix}/report/car_used`);

    return data;
  },
  async vehicle_usage () {
    const { data } = await httpClient({ requiresAuth: true }).get(`/${prefix}/report/vehicle-usage`);

    return data;
  },
  async vehicle_use_report () {
    const { data } = await httpClient({ requiresAuth: true }).get(`/${prefix}/report/vehicle-use-report`);

    return data;
  },
  async park_report () {
    const { data } = await httpClient({ requiresAuth: true }).get(`/${prefix}/report/park-report`);

    return data;
  },
  async park_booking () {
    const { data } = await httpClient({ requiresAuth: true }).get(`/${prefix}/report/park-booking`);

    return data;
  },


  async import_client (body) {
    const { data } = await httpClient({ requiresAuth: true }).post(`/import/clients`, { data: body });

    return data;
  },
  async import_car (body) {
    const { data } = await httpClient({ requiresAuth: true }).post(`/import/car`, { data: body });

    return data;
  },
  async import_driver (body) {
    const { data } = await httpClient({ requiresAuth: true }).post(`/import/driver`, { data: body });

    return data;
  }
}